import types from './types';

const initialState = {};

const dataGridFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_FILTER:
      let { searchOptions, api } = action.payload;

      return {
        ...state,
        [api]: searchOptions
      };

    case types.TOGGLE_AUTOMATIC_SPATIAL_QUERY:
      let { toggled } = action.payload;

      return {
        ...state,
        automaticSpatialQuery: toggled
      };

    default:
      return state;
  }
};

export default dataGridFiltersReducer;



// WEBPACK FOOTER //
// ./src/redux/dataGridFilters/reducers.js